import RetencionCrud from './RetencionCrud'
export {RetencionCrud}
export default RetencionCrud
